module.exports = __webpack_public_path__ + "img/21.3babcfb9.png";